<template>
  <div>
    <BaseDataTable
      :items="targetStatuses"
      :headers="TARGET_STATUSES_HEADERS"
      :itemps-per-page="-1"
      hide-default-footer
    >
      <template #item="{ item }">
        <tr>
          <td>
            <BaseParagraph type="primary" v-text="item.statusTo.name" />
          </td>
          <td>
            <BaseParagraph type="primary" v-text="item.label" />
          </td>
          <td>
            <div class="d-flex justify-end">
              <BaseButtonIcon
                x-small
                color="primary"
                icon="$mdiPencilOutline"
                class="mr-2"
                @click="editTargetStatus(item)"
              />
              <BaseButtonIcon
                color="secondary"
                x-small
                icon="$mdiTrashCanOutline"
                @click="
                  () => {
                    $store.commit('workflow/setActiveStatus', status);
                    $store.commit('workflow/setActiveTargetStatus', item);
                    $store.commit(
                      'workflow/setDeleteStatusTargetStatusDialog',
                      true
                    );
                  }
                "
              />
            </div>
          </td>
        </tr>
      </template>
    </BaseDataTable>
    <BaseDivider grey class="my-2" />
    <div class="d-flex justify-center mt-4">
      <BaseButton
        color="primary"
        :icon="'$mdiClipboardEditOutline'"
        small
        class="mb-2"
        @click="createAndEditDialogOpened = true"
      >
        {{ $t("workflow.status.addStatusCible") }}
      </BaseButton>
    </div>
    <!-- DIALOG SECTION -->
    <WorkflowStatusTargetStatusCreateAndEditDialog
      :dialog-state="createAndEditDialogOpened"
      :workflow="workflow"
      :status="status"
      :active-target-status="activeTargetStatus"
      :target-statuses="targetStatuses"
      @targetStatusCreated="handleTargetStatusCreated"
      @targetStatusUpdated="handleTargetStatusUpdated"
      @close="closeModal()"
    />
  </div>
</template>

<script>
import WorkflowStatusTargetStatusCreateAndEditDialog from "./WorkflowStatusTargetStatusCreateAndEditDialog";
import { fetchOrganizationWorkflowStatusTargetStatuses } from "@/modules/Admin/Services/workflow.service";
export default {
  name: "WorkflowDetailStatusTargetStatuses",
  components: {
    WorkflowStatusTargetStatusCreateAndEditDialog,
  },
  props: {
    status: {
      type: Object,
      required: true,
    },
    workflow: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      TARGET_STATUSES_HEADERS: [
        {
          text: this.$tc("organization.status", 1) + " cible",
          value: "name",
        },
        {
          text: this.$t("question.types.message"),
          value: "message",
        },
        {
          text: this.$tc("utils.action", 2),
        },
      ],
      targetStatuses: [],
      createAndEditDialogOpened: false,
      activeTargetStatus: null,
    };
  },
  created() {
    this.fetchTargetStatuses();
  },
  methods: {
    async fetchTargetStatuses() {
      const res = await fetchOrganizationWorkflowStatusTargetStatuses(
        this.$route.params.organizationId,
        this.$route.params.workflowId,
        this.status.id
      );
      this.targetStatuses = res.data.results;
    },
    editTargetStatus(targetStatus) {
      this.activeTargetStatus = targetStatus;
      this.createAndEditDialogOpened = true;
    },
    handleTargetStatusCreated(newTargetStatus) {
      this.targetStatuses.push(newTargetStatus);
    },
    handleTargetStatusUpdated(targetStatus) {
      this.targetStatuses = this.targetStatuses.map((ts) =>
        ts.id === targetStatus.id ? targetStatus : ts
      );
    },
    closeModal() {
      this.activeTargetStatus = null;
      this.createAndEditDialogOpened = false;
    },
  },
};
</script>
